import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {validators} from '../../../validation';
import Field from '../../Field';
import CongregationInput from '../../CongregationInput';
import {
  setCongregation,
  setCongregationErrors
} from '../../../actions/congregations';
import './CongregationForm.less';


const CongregationField = connect(
  state => ({
    value: state.congregations.selected,
    errors: state.congregations.errors,
    validators: [validators.required()],
    label: " "
  }),
  dispatch => ({
    onChange(value) {
      dispatch(setCongregation(value));
    },
    setErrors(errors) {
      dispatch(setCongregationErrors(errors));
    }
  })
)(Field);


export default class CongregationForm extends PureComponent {
  render() {
    return (
      <div className="congregation-form">
        <CongregationField>
          <CongregationInput />
        </CongregationField>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/form-route/forms/CongregationForm.js